<template>
  <section class="section is-main-section reported-item-list-section">
    <section class="has-listing-table">
      <div class="level no-margin">
        <div class="level-left">
          <span class="navbar-item no-padding">
            <a
              @click.prevent="additionalBulkCheck('export')"
              data-cy="pd-bulk-edit"
              >Export</a
            >
          </span>
        </div>
        <div class="level-right page-configs">
          <b-dropdown
            position="is-bottom-left"
            @active-change="onDropdownActiveChange"
          >
            <template #trigger>
              <a class="navbar-item navbar-mdi-tune-dropdown">
                <button class="button" data-cy="report-items-config-button">
                  <span class="mdi mdi-table-cog mdi-24px mdi-dark"></span>
                </button>
              </a>
            </template>
            <form>
              <div class="filter-config-modal-body">
                <!-- Fixed header that won't scroll -->
                <div class="filter-config-header">
                  <b-field label="Column Configuration">
                    <b-checkbox
                      v-model="allColumnsSelected"
                      @input="onSelectAllChange"
                    >
                      <strong>Select All</strong>
                    </b-checkbox>
                  </b-field>
                </div>
                <!-- Scrollable content section -->
                <section class="filter-config-list">
                  <!-- Select All checkbox -->
                  <div class="control select-all-control">
                    <b-dropdown-item
                      aria-role="list"
                      :focusable="false"
                      custom
                      paddingless
                    >
                    </b-dropdown-item>
                  </div>

                  <!-- Individual column checkboxes -->
                  <div
                    v-for="(column, index) in columns.filter(
                      col => col && col.field !== 'actions'
                    )"
                    :key="index"
                    class="control"
                  >
                    <div v-if="column.label != ''">
                      <b-dropdown-item
                        aria-role="list"
                        :focusable="false"
                        custom
                        paddingless
                      >
                        <b-checkbox
                          @input="onColumnVisibilityChange()"
                          v-model="column.visible"
                        >
                          {{ column.label }}
                        </b-checkbox>
                      </b-dropdown-item>
                    </div>
                  </div>
                </section>
              </div>
            </form>
          </b-dropdown>
        </div>
      </div>
      <div class="enable-select-text" v-if="columns.length > 0">
        <circul8-table
          :records="tableData"
          :fields="columns.filter(col => col.visible !== false)"
          :usePropRecords="true"
          :listingComponent="true"
          :isCheckable="true"
          :maxTextLength="'48'"
          :isLoading="isDataLoading"
          :showEditButton="true"
          :showRemoveButton="false"
          :allProductFamily="productFamily"
          :allMaterialDetail="materialDetail"
          @clickcheck="checkCheckBox"
          @checkedAll="checkedAllData"
          :checkedRows="checkedRow"
          @querySet="searchByFilter"
          :backendSortingEnabled="true"
          @backendSort="sortData"
          :enableSwitchAction="false"
          :routeNext="false"
          :showViewButton="false"
          :productFamilyDropDown="productFamilyDropDown"
          :materialDetailDropDown="materialDetailDropDown"
          :chemistryDropDown="chemistryDropDown"
          :packagingTypeDropDown="packagingTypeDropDown"
          :packagingLevelDropDown="packagingLevelDropDown"
        />
        <div class="records-displayed" v-if="totalRecords > 0">
          <span v-if="isCheckedAll"> All selected, </span>
          <span v-if="checkedData.length > 0 && !isCheckedAll"
            >{{ checkedData.length }} selected,
          </span>
          <span v-if="currentPage * 50 + 50 < totalRecords"
            >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
            {{
              currentPage > 0
                ? nextPageCursor
                  ? currentPage * 50 - 50 + tableData.length
                  : totalRecords
                : tableData.length
            }}
            records out of {{ totalRecords }} records</span
          >
          <div v-else>
            <span v-if="currentPage == 0">
              displaying 0 - {{ totalRecords }} records out of
              {{ totalRecords }} records
            </span>
            <span v-else>
              displaying {{ currentPage * 50 - 50 }} -
              {{ totalRecords }} records out of {{ totalRecords }} records
            </span>
          </div>
        </div>
      </div>
      <b-loading
        :is-full-page="false"
        v-model="isLoading"
        :can-cancel="true"
      ></b-loading>
    </section>
  </section>
</template>

<script>
import CDFProductDataService from "../../services/CDFProductDataService";
import CDFTransactionDataService from "../../services/CDFTransactionDataService";
import Circul8Table from "../../components/Circul8Table.vue";
import RulesManagerService from "../../services/RulesManagerService";
import ReportManagerService from "../../services/ReportManagerDataService";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import { CDFStream } from "../../constants/CDFStream";
import { FieldType } from "../../constants/FieldType";
//import Multiselect from "vue-multiselect";
let screenPixelSize;
let pixelRatio;
export default {
  name: "ReportedItemListView",
  props: {
    categoriesDropdownValues: {
      type: Array
    },
    rulesDropdownValue: {
      type: Array
    },
    productGroupDropDown: {
      type: Array
    },
    productFamilyDropDown: {
      type: Array
    },
    materialDetailDropDown: {
      type: Array
    },
    materialGeneralDropdown: {
      type: Array
    },
    chemistryDropDown: {
      type: Array
    },
    packagingTypeDropDown: {
      type: Array
    },
    packagingLevelDropDown: {
      type: Array
    },
    data: [Array, Object],
    isTest: {
      type: Boolean,
      default: true
    },
    summaryData: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [UserPermissionMixin, UtilityMixin, ScopeMixin],
  components: {
    Circul8Table
  },
  data() {
    return {
      checkedData: [],
      checkedRow: [],
      map1: new Map(),
      isCheckedAll: false,
      checkedDataMap: new Map(),
      tableData: [],
      formData: {},
      transColumns: [],
      isDataLoading: false,
      isModalActive: false,
      isUrgencyModalActive: false,
      action: null,
      isAdd: false,
      editObject: this.getClearFormObject(),
      viewOnly: false,
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      nextData: false,
      previousData: false,
      currentPage: 0,
      availableStream: {},
      productFamily: {},
      materialDetail: {},
      query: "",
      CDFProductDataService: new CDFProductDataService(),
      CDFTransactionDataService: new CDFTransactionDataService(),
      columns: [],
      cdf_product_sheet: [],
      cdf_transaction_sheet: [],
      RulesManagerService: new RulesManagerService(),
      ReportManagerService: new ReportManagerService(),
      category: null,
      categories: [],
      rules: [],
      rule: null,
      columnCreated: false,
      isLoading: true,
      exportLargeCount: 65000,
      scrollListenerAdded: false,
      switchCustomerId: null
    };
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }

    // Add window resize listener
    window.addEventListener("resize", this.adjustHeight);

    // Load column visibility from localStorage if available
    this.$nextTick(() => {
      // Initialize columns with all selected
      this.columns.forEach(col => {
        if (col) col.visible = true;
      });

      this.loadFieldConfig();
      this.adjustHeight();
    });

    // Fetch data if it's already available on mount
    // Check if data is an object (not array) and has properties
    const hasData =
      this.data &&
      typeof this.data === "object" &&
      !Array.isArray(this.data) &&
      Object.keys(this.data).length > 0;

    if (hasData) {
      let customerId = null;
      if (this.isTest) {
        customerId = this.data?.customer;
      } else {
        customerId = this.data?.general_information?.customer_id;
      }

      if (customerId) {
        this.fetchCDFProductData(customerId);
        this.fetchCDFTrasactionData(customerId);
      }
    }

    // window.addEventListener("scroll", this.handleScrollCloseDropdowns, true);
  },
  beforeDestroy() {
    // Remove the resize listener when component is destroyed
    window.removeEventListener("resize", this.adjustHeight);
    //window.removeEventListener("scroll", this.handleScrollCloseDropdowns, true);

    // Remove scroll event listener if it was added
    if (this.scrollListenerAdded && this.handleScroll) {
      const listElm = document.querySelector(".table-wrapper");
      if (listElm) {
        listElm.removeEventListener("scroll", this.handleScroll);
      }
      this.scrollListenerAdded = false;
    }
  },
  watch: {
    data: {
      handler(newValue, oldValue) {
        // Extract customer IDs from both old and new values
        let oldCustomerId = null;
        let newCustomerId = null;

        if (this.isTest) {
          oldCustomerId = oldValue?.customer;
          newCustomerId = newValue?.customer;
        } else {
          oldCustomerId = oldValue?.general_information?.customer_id;
          newCustomerId = newValue?.general_information?.customer_id;
        }

        // Only fetch if we have a new customer ID and it's different from the old one
        // This handles initial load (oldCustomerId is null) and prevents refetching on other data updates
        if (newCustomerId && newCustomerId !== oldCustomerId) {
          this.fetchCDFProductData(newCustomerId);
          this.fetchCDFTrasactionData(newCustomerId);
        }
      },
      deep: true,
      immediate: true
    },
    categoriesDropdownValues(newValue) {
      const CategoryIndex = this.find_column_index("reporting_category_name");
      if (CategoryIndex >= 0) {
        this.columns[CategoryIndex].allStatusVals = newValue;
      }
    },
    rulesDropdownValue(newValue) {
      const ruleIndex = this.find_column_index("rule_applied_name");
      if (ruleIndex >= 0) {
        this.columns[ruleIndex].allStatusVals = newValue;
      }
    },
    productGroupDropDown(newValue) {
      const ProductGroupIndex = this.find_column_index("product_group");
      if (ProductGroupIndex >= 0) {
        this.columns[ProductGroupIndex].allStatusVals = newValue;
      }
    },
    productFamilyDropDown(newValue) {
      const ProductFamilyIndex = this.find_column_index("product_family");
      if (ProductFamilyIndex >= 0) {
        this.columns[ProductFamilyIndex].allStatusVals = newValue;
      }
    },
    materialDetailDropDown(newValue) {
      const MaterialDetailIndex = this.find_column_index("material_detail");
      if (MaterialDetailIndex >= 0) {
        this.columns[MaterialDetailIndex].allStatusVals = newValue;
      }
    },
    materialGeneralDropdown(newValue) {
      const materialGeneralIndex = this.find_column_index("material_general");
      if (materialGeneralIndex >= 0) {
        this.columns[materialGeneralIndex].allStatusVals = newValue;
      }
    },
    chemistryDropDown(newValue) {
      const chemistryIndex = this.find_column_index("chemistry");
      if (chemistryIndex >= 0) {
        this.columns[chemistryIndex].allStatusVals = newValue;
      }
    },
    packagingTypeDropDown(newValue) {
      const packagingTypeIndex = this.find_column_index("packaging_type");
      if (packagingTypeIndex >= 0) {
        this.columns[packagingTypeIndex].allStatusVals = newValue;
      }
    },
    packagingLevelDropDown(newValue) {
      const packagingLevelIndex = this.find_column_index("packaging_level");
      if (packagingLevelIndex >= 0) {
        this.columns[packagingLevelIndex].allStatusVals = newValue;
      }
    },
    summaryData: {
      handler(newValue) {
        // When summaryData arrives, enrich existing table data
        if (
          newValue &&
          newValue.sheet_config &&
          this.tableData &&
          this.tableData.length > 0
        ) {
          // Re-enrich all existing records with the now-available summaryData
          this.tableData.forEach(record => {
            this.enrichDataWithSheetConfig(record);
          });
          // Force update to reflect the changes
          this.$forceUpdate();
        }
      },
      deep: true
    }
  },
  updated() {
    if (this.scrollListenerAdded) return;

    const listElm = document.querySelector(".table-wrapper");
    if (listElm) {
      this.handleScroll = e => {
        if (
          Math.round(listElm.scrollTop) +
            Math.round(listElm.clientHeight) -
            Math.round(listElm.scrollHeight) >=
          -5
        ) {
          if (this.nextData) {
            listElm.scrollTop = 50;
            this.pullNextPage();
          }
        } else {
          if (Math.round(listElm.scrollTop) == 0 && this.previousData) {
            listElm.scrollTop =
              Math.round(listElm.scrollHeight) -
              Math.round(listElm.clientHeight) -
              50;
            this.pullPreviousPage();
          }
        }
        this.checkSize();
        this.adjustHeight();
      };

      listElm.addEventListener("scroll", this.handleScroll);
      this.scrollListenerAdded = true;
    }
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", ""]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    titleStack() {
      return [
        { url: "#", name: "Report Manager" },
        { url: "/reportManager/testingList", name: "Report Test List" }
      ];
    },
    customerId() {
      if (this.isTest) {
        return this.data.customer;
      } else {
        return this.data.general_information.customer_id;
      }
    },
    allColumnsSelected: {
      get() {
        // If there are no columns, it's not selected
        if (!this.columns || this.columns.length === 0) return false;
        // Check if all non-action columns are selected
        const nonActionColumns = this.columns.filter(
          col => col && col.field !== "actions"
        );
        return nonActionColumns.every(col => col.visible === true);
      },
      set(value) {
        // Set all non-action columns to the selected value
        this.columns.forEach(col => {
          if (col && col.field !== "actions") {
            col.visible = value;
          }
        });
        // Always make sure action column is visible
        this.ensureActionsColumnVisible();
        // Save the configuration
        this.saveFieldConfig();
        // Force update to ensure UI reflects changes
        this.$forceUpdate();
      }
    }
  },
  methods: {
    onSelectAllChange(value) {
      // Explicitly set all column visibility
      this.columns.forEach(col => {
        if (col && col.field !== "actions") {
          this.$set(col, "visible", value);
        }
      });
      this.saveFieldConfig();
    },
    onColumnVisibilityChange() {
      // Update the select all state when individual columns change
      this.saveFieldConfig();
    },
    additionalBulkCheck() {
      let msg = "";
      if (this.isCheckedAll && this.totalRecords > this.exportLargeCount) {
        msg =
          `Are you sure you want to export more than ` +
          this.exportLargeCount +
          ` records? Exported file will be sent to your email address`;
      } else {
        msg =
          `Are you sure you want to export ` +
          (this?.isCheckedAll
            ? `all`
            : `selected ` + this?.checkedData?.length) +
          ` records?`;
      }

      if (this.checkedData.length > 50 || this.isCheckedAll) {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          message: msg,
          trapFocus: true,
          onConfirm: v => this.exportReport(true)
        });
      } else {
        this.exportReport(false);
      }
    },
    handleScrollCloseDropdowns(event) {
      if (document.contains(event.target)) {
        // Deactivate all elements with class "multiselect"
        document.querySelectorAll(".multiselect").forEach(el => {
          if (el.__vue__ && typeof el.__vue__.deactivate === "function") {
            el.__vue__.deactivate();
          }
        });
      }
    },
    exportReport(value) {
      this.isLoading = true;
      const isExportedAll = value;
      let totalCount = this.checkedData.length;
      if (this?.isCheckedAll) {
        totalCount = this.totalRecords;
      }
      try {
        this.ReportManagerService.exportReport(
          this.customerId,
          this.$route.params.id,
          this.isTest,
          this.checkedData.map(records => records.id),
          this.query,
          isExportedAll,
          this.columns,
          totalCount,
          this.switchCustomerId
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: e.message
        });
        this.isLoading = false;
      }

      this.isCheckedAll = false;
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isLoading = false;
    },
    createNewColumns(headers, data, scrollDir) {
      this.isTest
        ? this.prepareProductColumns(
            this.cdf_product_sheet,
            this.data.stream,
            headers,
            data,
            scrollDir
          )
        : this.prepareProductColumns(
            this.cdf_product_sheet,
            this.data.general_information.stream_id,
            headers,
            data,
            scrollDir
          );
    },
    prepareNewColumns(data, headers, prepareNewColumns, scrollDir) {
      if (!this.columnCreated && prepareNewColumns) {
        this.columnCreated = true; // Fixed assignment operator (was ==)
        this.createNewColumns(headers, data, scrollDir);

        // Ensure all columns are visible by default
        this.columns.forEach(col => {
          if (col) col.visible = true;
        });
      } else {
        this.prepareData(data, scrollDir);
      }
    },
    fetchReportedItemData(query = "", isColumnLoaded, scrollDir) {
      this.ReportManagerService.getReportedItemData(
        this.customerId,
        this.$route.params.id,
        this.isTest,
        query,
        this.switchCustomerId
      ).subscribe(
        response => {
          this.PreviousPageCursor = this.nextPageCursor
            ? this.nextPageCursor
            : this.PreviousPageCursor;
          this.nextPageCursor = response["next"];
          if (this.currentPage > 1) {
            this.previousData = true;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          } else {
            this.enableLoadMore = this.previousData = false;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          }
          this.totalRecords = response["count"];
          let tempData = [];
          if (scrollDir == "next") {
            //this.totalRecords = this.data.length + response["count"];
            if (!this.nextPageCursor) {
              this.prepareNewColumns(
                response["results"],
                response["header_fields"],
                isColumnLoaded,
                scrollDir
              );
            } else {
              tempData = [...this.tableData, ...response["results"]];
              if (tempData.length > 100 && this.nextPageCursor != null) {
                tempData = tempData.slice(50, 150);
              }
              this.prepareNewColumns(
                tempData,
                response["header_fields"],
                isColumnLoaded,
                scrollDir
              );
            }
          } else if (scrollDir == "prev") {
            if (this.currentPage == 0) {
              this.prepareNewColumns(
                response["results"],
                response["header_fields"],
                isColumnLoaded,
                scrollDir
              );
            } else {
              tempData = [...response["results"], ...this.tableData];
              if (tempData.length >= 100) {
                tempData = tempData.slice(0, 100);
              }

              this.prepareNewColumns(
                tempData,
                response["header_fields"],
                isColumnLoaded,
                scrollDir
              );
            }
          } else {
            this.prepareNewColumns(
              response["results"],
              response["header_fields"],
              isColumnLoaded,
              scrollDir
            );
          }
          // this.prepareNewColumns(
          //   response["results"],
          //   response["header_fields"],
          //   isColumnLoaded
          // );
          //this.prepareData();
        },
        e => {
          this.isDataLoading = false;
          this.isLoading = false;
        }
      );
    },

    fetchCDFTrasactionData(customerId) {
      this.CDFTransactionDataService.getCdfTransactionField(
        customerId
      ).subscribe(
        response => {
          this.cdf_transaction_sheet = response;
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },
    fetchCDFProductData(customerId) {
      this.CDFProductDataService.getAll(customerId).subscribe(
        response => {
          this.cdf_product_sheet = response;
          this.fetchReportedItemData(this.query, true);
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },
    prepareTransactionColumns(data, headers, preData, scrollDir) {
      // dynamically generate columns based on customer and stream
      const cdf_columns =
        data && data[0] && data[0]["template_fields"]
          ? data[0]["template_fields"]
          : [];
      let pos_of_weight_in_kg = 0;

      // If no CDF columns and no columns created yet, create defaults
      if (cdf_columns.length === 0 && this.columns.length === 0) {
        this.columns = Object.keys(headers).map((element, i) => ({
          field: element,
          label: this.titleCase(headers[element]),
          searchable: true,
          type: "input",
          width: "250",
          visible: true,
          filterKey: { [element]: "" }
        }));
      }
      Object.keys(headers).forEach((element, i) => {
        cdf_columns.forEach(e => {
          if (element === e.transaction_data_column) {
            let type = "";
            let multiSelectFilter = "false";
            type = this.getFieldType(e.field_type);
            const filterKey = {};
            const allStatusVals = [];
            const editableCheck = e?.editable_check ? e.editable_check : false;
            const field_name = e.transaction_data_column;
            const label_name = this.titleCase(headers[element]);
            if (type == "multiSelectFilter") {
              multiSelectFilter = "true";
              filterKey[field_name] = [];
              filterKey["field_name"] = "name";
            } else {
              filterKey[field_name] = "";
            }
            if (e.dropdown_field_values?.length > 0) {
              e.dropdown_field_values.forEach(element => {
                allStatusVals.push({ name: element });
              });
            }
            if (field_name != "product_number") {
              this.columns[i] = {
                field: field_name,
                label: label_name,
                width: "250",
                searchable: true,
                filterKey: filterKey,
                type: type,
                multiSelectFilter: multiSelectFilter,
                initStatusVals: [],
                allStatusVals: allStatusVals,
                editableCheck: editableCheck,
                visible: true // Set columns to be visible by default
              };
            }
          } else {
            if (element === "reporting_category_name") {
              this.columns[i] = {
                field: "reporting_category_name",
                label: "Reporting Category",
                searchable: true,
                type: "multiSelectFilter",
                width: "300",
                filterKey: {
                  reporting_category_name: []
                },
                initStatusVals: [],
                allStatusVals: this.categoriesDropdownValues,
                visible: true // Set columns to be visible by default
              };
            } else if (
              element === "rule_applied_name" &&
              !this.userExternalCheck()
            ) {
              this.columns[i] = {
                field: "rule_applied_name",
                label: "Rule Applied",
                searchable: true,
                type: "multiSelectFilter",
                width: "200",
                visible: true, // Set columns to be visible by default
                filterKey: {
                  rule_applied_name: []
                },
                initStatusVals: [],
                allStatusVals: this.rulesDropdownValue
              };
            } else if (this.columns[i]) {
              return;
            } else {
              if (element == "t_product_number") {
                pos_of_weight_in_kg = i;
              }
              if (element == "product_number_bundle") {
                this.columns.splice(pos_of_weight_in_kg + 1, 0, {
                  field: element,
                  label: this.titleCase(headers[element]),
                  searchable: true,
                  filterKey: { element: "" },
                  type: "input",
                  width: "250"
                });
              } else {
                this.columns[i] = {
                  field: element,
                  label: this.titleCase(headers[element]),
                  searchable: true,
                  filterKey: { element: "" },
                  type: "input",
                  width: "250",
                  visible: true // Set columns to be visible by default
                };
              }
            }
          }
        });
      });
      this.columns = this.getUniqueListBy(this.columns, "field");
      //this.columns.sort((a, b) => a?.field - b?.field);

      // Ensure all columns are visible by default
      this.columns.forEach(col => {
        if (col) col.visible = true;
      });

      // Load column configuration from localStorage after columns are created
      this.$nextTick(() => {
        this.loadFieldConfig();
      });

      this.columns.push({
        field: "actions",
        label: "",
        headerClass: "is-actions",
        cellClass: "is-actions",
        visible: true,
        searchable: true,
        type: "actionSearch",
        actionSearch: true,
        filterKey: { actions: "" }
      });
      this.prepareData(preData, scrollDir);
      this.isLoading = false;
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    titleCase(str) {
      return str
        .toLowerCase()
        .split(" ")
        .map(function(word) {
          return word.replace(word[0], word[0].toUpperCase());
        })
        .join(" ");
    },

    prepareProductColumns(data, stream, headers, preData, scrollDir) {
      // dynamically generate columns based on customer and stream
      const cdf_columns =
        data && data[0] && data[0]["template_fields"]
          ? data[0]["template_fields"]
          : [];
      let cdf_product_sheet = [];
      if (stream == 2) {
        cdf_product_sheet = cdf_columns.filter(
          e =>
            e.field_required &&
            (e.sheet_name === CDFStream.BATT ||
              e.sheet_name === CDFStream.PRODUCT_SHEET)
        );
      } else if (stream == 3) {
        cdf_product_sheet = cdf_columns.filter(
          e =>
            e.field_required &&
            (e.sheet_name === CDFStream.PACK ||
              e.sheet_name === CDFStream.PRODUCT_SHEET)
        );
      } else if (stream == 1) {
        cdf_product_sheet = cdf_columns.filter(
          e =>
            e.field_required &&
            (e.sheet_name === CDFStream.WEEE ||
              e.sheet_name === CDFStream.PRODUCT_SHEET)
        );
      } else if (stream == CDFStream.BUNDLE) {
        cdf_product_sheet = cdf_columns.filter(
          e =>
            e.field_required &&
            (e.sheet_name === CDFStream.BUNDLE ||
              e.sheet_name === CDFStream.PRODUCT_SHEET)
        );
      } else {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.PRODUCT_SHEET
        );
      }
      this.columns = [];
      Object.keys(headers).forEach((elm, i) => {
        cdf_product_sheet.forEach(e => {
          if (elm === e.report_generation_data_column) {
            let type = "";
            let multiSelectFilter = "false";
            type = this.getFieldType(e.field_type);
            const filterKey = {};
            let allStatusVals = [];
            if (e.dropdown_field_values?.length > 0) {
              e.dropdown_field_values.forEach(element => {
                if (e.report_generation_data_column == "product_family") {
                  Object.keys(element).forEach(key => {
                    this.productFamily[`${key}`] = [];
                  });
                  this.productFamilyDropDown.forEach(val => {
                    Object.keys(element).forEach(key => {
                      const value = element[key];
                      if (value.includes(val.name)) {
                        this.productFamily[`${key}`].push(val.name);
                      }
                    });
                  });
                  allStatusVals = this.productFamilyDropDown;
                } else if (
                  e.report_generation_data_column == "material_detail"
                ) {
                  Object.keys(element).forEach(key => {
                    this.materialDetail[`${key}`] = [];
                  });
                  this.materialDetailDropDown.forEach(val => {
                    Object.keys(element).forEach(key => {
                      const value = element[key];
                      if (value.includes(val.name)) {
                        this.materialDetail[`${key}`].push(val.name);
                      }
                    });
                  });
                  allStatusVals = this.materialDetailDropDown;
                } else {
                  allStatusVals.push({ name: element });
                }
              });
            }
            if (e.report_generation_data_column == "product_group") {
              allStatusVals = this.productGroupDropDown;
            }
            if (e.report_generation_data_column == " material_general") {
              allStatusVals = this.materialGeneralDropdown;
            }
            if (e.product_data_column == "chemistry") {
              allStatusVals = this.chemistryDropDown;
            }
            if (e.product_data_column == "packaging_type") {
              allStatusVals = this.packagingTypeDropDown;
            }
            if (e.product_data_column == "packaging_level") {
              allStatusVals = this.packagingLevelDropDown;
            }
            const editableCheck = e?.editable_check ? e.editable_check : false;
            const field_name = e.report_generation_data_column;
            const label_name = this.titleCase(headers[elm]);
            if (type == "multiSelectFilter") {
              multiSelectFilter = "true";
              filterKey[field_name] = [];
              filterKey["field_name"] = "name";
            } else {
              filterKey[field_name] = "";
            }
            if (field_name != "product_number") {
              this.columns[i] = {
                field: field_name,
                label: label_name,
                searchable: true,
                filterKey: filterKey,
                width: "250",
                type: type,
                multiSelectFilter: multiSelectFilter,
                initStatusVals: [],
                allStatusVals: allStatusVals,
                editableCheck: editableCheck,
                visible: true // Set columns to be visible by default
              };
            }
          }
        });
      });
      this.prepareTransactionColumns(
        this.cdf_transaction_sheet,
        headers,
        preData,
        scrollDir
      );
      //this.columns.sort((a, b) => a?.template_field - b?.template_field);
      //this.columns = this.getUniqueListBy(this.columns, "field");
      //this.fetchProductData(stream);
      // this.cdf_product_config_sheet = cdf_product_sheet;
    },

    getFieldType(value) {
      switch (value) {
        case FieldType.TEXT:
          return "input";
        case FieldType.DATE:
          return "dateField";
        case FieldType.NUMBER:
          return "input";
        case FieldType.DROPDOWN:
          return "multiSelectFilter";
        case FieldType.NUMBERRANGE:
          return "numberRange";
        default:
          return "input";
      }
    },
    closeUrgencyModal() {
      this.editObject = {};
      this.isUrgencyModalActive = false;
    },
    closeGenerateTestRunModal() {
      this.isModalActive = false;
    },
    checkUrgency(editObject) {
      this.isModalActive = false;
      this.editObject = editObject;
      this.isUrgencyModalActive = true;
    },
    generateTestRun() {
      this.isModalActive = true;
    },

    getClearFormObject() {
      return {
        customer: null,
        country: null,
        scheme: null,
        stream: null,
        report_definition: null,
        period: null,
        execution_urgency: null
      };
    },

    runTest(editObject) {
      this.editObject.execution_urgency = editObject;
      this.ReportManagerService.generateTestRun(this.editObject).subscribe(
        () => {
          this.$buefy.toast.open({
            message: "Data is added successfully!",
            type: "is-success"
          });
          this.isUrgencyModalActive = false;
          this.getGeneratedTestRun();
        },
        this.handleApiError
      );
    },

    prepareData(data, scrollDir) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        // Enrich data with sheet config information if available
        this.enrichDataWithSheetConfig(reportData);
        dataList.push(reportData);
      }

      if (!scrollDir) {
        // Initial load: always set tableData
        this.tableData = dataList;
      } else {
        // Scroll load: append or set based on cursor
        if (this.nextPageCursor == null) {
          this.tableData.push(...dataList);
          if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            if (this.currentPage == 1) {
              this.previousData = false;
            }
          } else {
            this.currentPage = this.currentPage - 1;
            this.previousData = false;
          }
        } else {
          this.tableData = dataList;
        }
      }
      this.isLoading = false;
      this.isDataLoading = false;
      this.$emit("isLoaded");
    },

    enrichDataWithSheetConfig(record) {
      // Add sheet config data to each record if available
      if (!this.summaryData || !this.summaryData.sheet_config) {
        return;
      }

      // Skip if record already has these values from API
      if (
        record.report_definition_table_id &&
        record.report_definition_table_header_id
      ) {
        return;
      }

      // Get the table name from the record or query parameter
      let tableName = record.table_name;
      if (!tableName) {
        tableName = this.extractTableNameFromQuery();
      }

      if (!tableName) {
        return;
      }

      // Find the matching table in sheet_config
      for (const sheet of this.summaryData.sheet_config) {
        if (!sheet.tables) continue;

        for (const table of sheet.tables) {
          // Match by table_name or table_json.tableName
          const tableNameFromConfig =
            table.table_name || table.table_json?.tableName;
          if (tableNameFromConfig === tableName || table.id === tableName) {
            // Map table ID
            if (!record.report_definition_table_id) {
              record.report_definition_table_id = table.id;
            }

            // Get header IDs from table_json
            if (
              table.table_json &&
              table.table_json.headers &&
              table.table_json.headers.length > 0
            ) {
              // Use the first header ID or match by header name if needed
              if (!record.report_definition_table_header_id) {
                record.report_definition_table_header_id =
                  table.table_json.headers[0].id ||
                  table.table_json.headers[0].key;
              }

              // For rule_applied_table_header_id, try to find matching rule header
              if (!record.rule_applied_table_header_id) {
                if (record.rule_applied_name) {
                  // Find header with matching rule
                  const ruleHeader = table.table_json.headers.find(
                    h =>
                      h.selectedRule?.name === record.rule_applied_name ||
                      h.name === record.rule_applied_name
                  );
                  record.rule_applied_table_header_id =
                    ruleHeader?.id ||
                    ruleHeader?.key ||
                    record.report_definition_table_header_id;
                } else {
                  // If no rule applied, use first header as fallback
                  record.rule_applied_table_header_id =
                    record.report_definition_table_header_id;
                }
              }
            }
            return;
          }
        }
      }
    },

    extractTableAndSheetParams(queryString) {
      if (!queryString) return "";

      let params = "";

      // Extract table_name parameter
      const tableMatch = queryString.match(/&table_name=([^&]+)/);
      if (tableMatch) {
        params += "&table_name=" + tableMatch[1];
      }

      // Extract sheet_name parameter
      const sheetMatch = queryString.match(/&sheet_name=([^&]+)/);
      if (sheetMatch) {
        params += "&sheet_name=" + sheetMatch[1];
      }

      return params;
    },

    extractTableNameFromQuery() {
      // Extract table_name from query string if available
      const match = this.query.match(/table_name=([^&]+)/);
      return match ? match[1] : null;
    },

    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      let query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      query_part = [...new Set(query_part)];
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          "&" + query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        //this.query = "&" + this.query;
        this.fetchReportedItemData(this.query, null, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = "&" + query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query =
          "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchReportedItemData(this.query, null, "prev");
    },
    checkedAllData(value) {
      this.isCheckedAll = value;
      if (!this.isCheckedAll) {
        this.checkedRow = [];
        this.map1 = new Map();
        this.checkedDataMap = new Map();
        this.checkedData = [];
      } else {
        this.checkedDataMap.set(this.currentPage, this.tableData);
      }
    },
    checkCheckBox(d) {
      // select all should be false now
      const total_checked = this.checkedData.length;
      const indexs = [];
      //getting the index of the checked rows
      d.forEach(element => {
        const index = this.tableData.findIndex(object => {
          return element.id === object.id;
        });
        indexs.push(index);
      });
      // create 2 dictonary. one with indexes for showing current page selected another with checked row vvalue
      this.map1.set(this.currentPage, indexs);

      if (d.length > 0) {
        this.checkedDataMap.set(this.currentPage, d);
      } else {
        !this.isCheckedAll && this.checkedDataMap.set(this.currentPage, d);
      }
      this.checkedRow = d;
      this.checkedData = [];
      // converting mapped data into array for bulk operations
      this.checkedDataMap.forEach(element => {
        this.checkedData.push(...element);
      });
      // if checked all is true and deselect any
      if (this.isCheckedAll && total_checked > this.checkedData.length) {
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
        this.map1 = new Map();
      }
    },
    searchByFilter(filterQuery) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;

      // Preserve table_name and sheet_name from existing query
      const existingParams = this.extractTableAndSheetParams(this.query);

      this.query = "&" + filterQuery + existingParams;
      //      this.displayedRecords = 0;

      let query = "";
      // Maintaining sort column & order in separate varaibles instead of this.query as it becomes difficult to replace & maintain
      // sort column & order part of this.query string. We should maintain query params in associative array instead of string
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn + "&";
        query += "&order_by" + "=" + this.lastSortOrder + "&";
        query += this.query;
      } else {
        query = this.query;
      }

      this.fetchReportedItemData(query);
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");

      const oldOrderField = "&order_field" + "=" + this.lastSortColumn + "&";
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder + "&";
      const newOrderField = "&order_field" + "=" + field + "&";
      const newOrderValue = "&order_by" + "=" + order + "&";

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchReportedItemData(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },

    handleApiError(reason) {
      let errorMessage = reason.response.data["detail"];

      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.isDataLoading = false;
    },

    checkSize() {
      screenPixelSize = screen.width;
      pixelRatio =
        window.devicePixelRatio ||
        window.screen.availWidth / document.documentElement.clientWidth;
      pixelRatio = pixelRatio.toFixed(1);
      if (
        (screenPixelSize > 1024 &&
          screenPixelSize < 1281 &&
          pixelRatio == 1.5) ||
        (screenPixelSize > 1580 && screenPixelSize < 1921 && pixelRatio == 1.5)
      ) {
        this.subHeight = this.subHeight - 15;
      }
      this.$refs.multiselect &&
        this.$refs.multiselect.forEach(element => {
          element.deactivate();
        });
      this.$refs.dropdown &&
        this.$refs.dropdown.forEach(element => {
          element.isActive = false;
        });
      this.$refs.datePicker &&
        this.$refs.datePicker.forEach(element => {
          element.closePopup();
        });
    },

    adjustHeight() {
      const browser_height = window.innerHeight;
      const newTableHeight = browser_height - this.subHeight;

      // Adjust table height
      const tableWrapper = document.querySelector(".table-wrapper");
      if (tableWrapper) {
        tableWrapper.style.maxHeight = newTableHeight + "px";
      }
    },

    // Handles dropdown open/close events
    onDropdownActiveChange(isActive) {
      // When a dropdown is opened, adjust its height
      if (isActive) {
        this.$nextTick(() => {
          // Adjust dropdown list height if active
          const browser_height = window.innerHeight;
          const newTableHeight = browser_height - this.subHeight;

          const filterConfigList = document.querySelector(
            ".filter-config-list"
          );
          if (filterConfigList) {
            filterConfigList.style.maxHeight = `${newTableHeight - 40}px`;
          }
        });
      }
    },

    // Handle "Select All" checkbox
    selectAllColumns(value) {
      // Set all non-action columns to the selected value
      this.columns.forEach(col => {
        if (col && col.field !== "actions") {
          col.visible = value;
        }
      });

      // Always make sure action column is visible
      this.ensureActionsColumnVisible();

      // Save the configuration
      this.saveFieldConfig();
    },

    // Save visible column configuration to localStorage
    saveFieldConfig() {
      // Make sure actions column is always visible
      this.ensureActionsColumnVisible();

      // Get visible column fields (excluding actions column which is always visible)
      const visibleFields = this.columns
        .filter(col => col && col.visible === true && col.field !== "actions")
        .map(col => col.field)
        .filter(Boolean); // Filter out any undefined values

      // Save to localStorage (ensure actions is always included)
      localStorage.setItem(
        `reportedItemListFields_${this.userId}_report_${this.$route.params.id}`,
        JSON.stringify(visibleFields)
      );

      // Force a re-render of the table
      this.$nextTick(() => {
        if (this.$refs.circul8Table) {
          this.$refs.circul8Table.$forceUpdate();
        }

        // After the DOM update, recalculate the table height
        this.adjustHeight();
      });
    },

    // Load column configuration from localStorage
    loadFieldConfig() {
      try {
        // First, make sure all columns are visible by default
        this.columns.forEach(col => {
          if (col) col.visible = true;
        });

        // Get stored visible fields from localStorage with user-specific and report-specific key
        const reportSpecificKey = `reportedItemListFields_${this.userId}_report_${this.$route.params.id}`;
        const userSpecificKey = `reportedItemListFields_${this.userId}`;
        const oldKey = "reportedItemListFields";

        // Try to get config in order of specificity
        let storedFields = localStorage.getItem(reportSpecificKey);

        // If report-specific config doesn't exist, try user-specific config
        if (!storedFields) {
          storedFields = localStorage.getItem(userSpecificKey);
        }

        // If neither exists, try old format as fallback
        if (!storedFields) {
          storedFields = localStorage.getItem(oldKey);
        }

        // If there's a stored configuration, apply it
        if (storedFields) {
          try {
            const visibleFields = JSON.parse(storedFields);

            // Only apply the stored configuration if it's valid and not empty
            if (Array.isArray(visibleFields) && visibleFields.length > 0) {
              // Update column visibility based on stored configuration
              this.columns.forEach(col => {
                if (col && col.field !== "actions") {
                  // Keep actions column always visible
                  col.visible = visibleFields.includes(col.field);
                }
              });
            } else {
              // If stored fields array is empty, make sure all are visible
              this.columns.forEach(col => {
                if (col) col.visible = true;
              });
            }
          } catch (parseError) {
            console.error("Error parsing stored fields:", parseError);
          }
        }

        // Always ensure actions column is visible and save the configuration
        this.ensureActionsColumnVisible();
        // If we loaded from a non-report-specific format, save in the new report-specific format
        if (localStorage.getItem(reportSpecificKey) === null && storedFields) {
          this.saveFieldConfig();
        }

        // Force a re-render of the table with updated visibility
        this.$forceUpdate();
      } catch (error) {
        console.error("Error loading field configuration:", error);
        // On error, make sure all columns are visible
        this.columns.forEach(col => {
          col.visible = true;
        });
        this.ensureActionsColumnVisible();
      }
    },

    // Helper method to ensure the actions column is always visible
    ensureActionsColumnVisible() {
      // Find actions column and make sure it's always visible
      const actionsColumn = this.columns.find(
        col => col && col.field === "actions"
      );
      if (actionsColumn) {
        actionsColumn.visible = true;
      }
    },
    loadTable(tableName, sheetName = "") {
      // Reset data for new table
      this.tableData = [];
      this.currentPage = 0;
      this.nextPageCursor = "";
      this.PreviousPageCursor = "";
      this.loadMoreClicked = false;
      this.lastSortColumn = null;
      this.lastSortOrder = null;
      this.enableLoadMore = false;
      this.totalRecords = 0;
      this.nextData = false;
      this.previousData = false;
      this.checkedData = [];
      this.checkedRow = [];
      this.map1 = new Map();
      this.isCheckedAll = false;
      this.checkedDataMap = new Map();

      // Build query with both table_name and sheet_name if available
      this.query = "&table_name=" + tableName;
      if (sheetName) {
        this.query += "&sheet_name=" + sheetName;
      }

      this.columnCreated = false; // Reset to allow re-creating columns
      this.fetchReportedItemData(this.query, true);
    }
  }
};
</script>

<style scoped>
/* Configure dropdown styling */
:deep(.filter-config-modal-body) {
  display: flex;
  flex-direction: column;
  max-height: 70vh;
  width: 300px;
  padding: 0 !important;
}

:deep(.filter-config-header) {
  position: sticky;
  top: 0;
  background-color: white;
  padding: 15px 15px 0px;
  z-index: 2;
}

:deep(.filter-config-list) {
  overflow-y: auto;
  padding: 0px 15px;
  scrollbar-width: thin;
}
/* Ensure checkbox items wrap properly */
:deep(.dropdown-item) {
  padding: 5px 10px;
  white-space: normal;
  line-height: 1.4;
  height: auto;
}

:deep(.control) {
  margin-bottom: 5px;
}

:deep(.checkbox) {
  overflow-wrap: break-word;
  word-break: break-word;
}

/* Improve scrollbar visibility */
:deep(.filter-config-list::-webkit-scrollbar) {
  width: 8px;
}

:deep(.filter-config-list::-webkit-scrollbar-track) {
  background: #f1f1f1;
  border-radius: 4px;
}

:deep(.filter-config-list::-webkit-scrollbar-thumb) {
  background: #888;
  border-radius: 4px;
}

:deep(.filter-config-list::-webkit-scrollbar-thumb:hover) {
  background: #555;
}
</style>
